enum AdminSettingsActionTypes {
    SET_TEMPLATE_EDIT_MODE_ENABLED = 'SET_TEMPLATE_EDIT_MODE_ENABLED',
    SET_MAINTENANCE_MODE_ENABLED = 'SET_MAINTENANCE_MODE_ENABLED',
}

export default AdminSettingsActionTypes;
